module.exports = __webpack_public_path__ + "img/help.d9b50906.svg";